export const weddingFormCoupleQuestions = (inputs) => [
  {
    text: 'RELACIÓN ACTUAL',
    type: 'title',
  },
  {
    text: 'Agreguen una foto de los dos',
    type: 'photo',
    id: 'couple_picture',
    class: 'couple-photo-container',
  },
  {
    text: 'Año en el que realizaron el seminario de Proyecto Matrimonio:',
    type: 'input',
    id: 'seminar_year',
  },
  {
    text: 'Semestre en el que realizaron el seminario de Proyecto Matrimonio:',
    type: 'input',
    id: 'seminar_semester',
  },
  {
    text: 'Nombre de la pareja líder que los acompañó en el seminario de Proyecto Matrimonio:',
    type: 'input',
    id: 'leader_couple_name',
  },
  {
    text: '¿Cuánto tiempo llevan de conocidos?:',
    type: 'input',
    id: 'time_known',
  },
  {
    text: '¿Cuánto tiempo llevan de noviazgo?:',
    type: 'input',
    id: 'dating_time',
  },
  {
    text: '¿Conviven?',
    type: 'select',
    options: ['Sí', 'No'],
    id: 'living_together',
  },
  ...(inputs?.[`living_together`] === 'Sí'
    ? [
        {
          text: '¿Hace cuánto?:',
          type: 'input',
          id: 'living_together_time',
        },
      ]
    : []),
  {
    text: '¿Tienen hijos en común?',
    type: 'select',
    options: ['Sí', 'No'],
    id: 'have_children_together',
  },
  ...(inputs?.[`have_children_together`] === 'Sí'
    ? [
        {
          text: '¿Cuántos?:',
          type: 'input',
          kind: 'number',
          id: 'children_together_count',
        },
      ]
    : []),
  {
    text: 'PROYECCIÓN DE LA BODA',
    type: 'title',
  },
  {
    text: 'Fecha de Ceremonia Cristiana:',
    type: 'date',
    id: 'christian_ceremony_date',
  },
  {
    text: 'Hora:',
    type: 'input',
    kind: 'time',
    id: 'ceremony_time',
  },
  {
    text: 'Lugar:',
    type: 'input',
    id: 'ceremony_location',
  },
  {
    text: '¿Qué Pastor desea que los case?',
    class: 'pastor-question',
    type: 'text',
  },
  {
    text: 'Nota: P. Juangui y P. Andrés actualmente no están celebrando ceremonias matrimoniales.',
    textOnlyInQuestions: true,
    type: 'text',
  },
  {
    text: 'Opción 1',
    type: 'input',
    id: 'pastor_option_1',
  },
  {
    text: 'Opción 2',
    type: 'input',
    id: 'pastor_option_2',
  },
  {
    text: 'Fecha Matrimonio Civil:',
    type: 'date',
    id: 'civil_marriage_date',
  },
  {
    text: 'ESTAMOS DE ACUERDO EN QUE NUESTRA CEREMONIA CRISTIANA SE PUEDE REALIZAR SI ENTREGAMOS EL CERTIFICADO DE MATRIMONIO CIVIL CON SELLOS DE NOTARÍA ORIGINALES EN FÍSICO, CON UN PLAZO MÁXIMO DE 4 DÍAS ANTES DE LA CEREMONIA RELIGIOSA DE LO CONTRARIO NO SE REALIZARÁ LA CEREMONIA.',
    type: 'text',
  },
  {
    type: 'habeasData',
  },
];

// Helper text for the agreement section
export const agreementText = `ESTAMOS DE ACUERDO EN QUE NUESTRA CEREMONIA CRISTIANA SE PUEDE REALIZAR SI ENTREGAMOS EL CERTIFICADO DE MATRIMONIO CIVIL CON SELLOS DE NOTARÍA ORIGINALES EN FÍSICO, CON UN PLAZO MÁXIMO DE 4 DÍAS ANTES DE LA CEREMONIA RELIGIOSA DE LO CONTRARIO NO SE REALIZARÁ LA CEREMONIA.`;

// Note about pastors
export const pastorNote = `Nota: P. Juangui y P. Andrés actualmente no están celebrando ceremonias matrimoniales.`;
